import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './initStore';

export interface ITooltipProps {
    position: PDFViewCtrl.Position;
    text: string;
}

export interface ITooltipState {
    props: ITooltipProps | null;
}

export const tooltipSlice = createSlice({
    name: 'tooltip',
    initialState: { props: null } as ITooltipState,
    reducers: {
        update: (state, action: PayloadAction<ITooltipProps | null>) => {
            state.props = action.payload;
        },
    },
});

export const { update } = tooltipSlice.actions;
export const tooltipVisibility = (state: IGlobalStoreReducers) => state.tooltip.props;

export default tooltipSlice.reducer;
